var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"session":_vm.session,"participant":_vm.participant}},[_c('rating',{attrs:{"session":_vm.session,"translations":_vm.translations,"participant":_vm.participant,"question":_vm.currentQuestion,"answerParameters":_vm.answerParameters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }